"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportTimeRangeConstraint = exports.ExportTimeRange = void 0;
const class_validator_1 = require("class-validator");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const enums_1 = require("../../enums");
dayjs_1.default.extend(utc_1.default);
function ExportTimeRange(exportTimeProperty, startDateProperty, frequencyProperty, validationOptions) {
    return (object, propertyName) => {
        (0, class_validator_1.registerDecorator)({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [exportTimeProperty, startDateProperty, frequencyProperty],
            validator: ExportTimeRangeConstraint
        });
    };
}
exports.ExportTimeRange = ExportTimeRange;
let ExportTimeRangeConstraint = class ExportTimeRangeConstraint {
    validate(exportEndTime, args) {
        const [exportTimeField, startDateField, frequencyPropertyName] = args.constraints;
        const object = args.object;
        const exportTime = object[exportTimeField];
        const jsStartDate = object[startDateField];
        // Format the start date as a string to ensure it is in the correct format
        const startDate = dayjs_1.default.utc(jsStartDate).format('YYYY-MM-DD');
        const frequencyValue = object[frequencyPropertyName];
        // If any of the required fields are missing, skip validation
        if (!frequencyValue || !exportTime || !exportEndTime || !startDate) {
            return true;
        }
        if (frequencyValue !== enums_1.ExportFrequency.Hourly) {
            return true;
        }
        // Convert times to dayjs objects, using the same date for both to simplify time comparison
        const startTime = dayjs_1.default.utc(`${startDate}T${exportTime}`);
        const endTime = dayjs_1.default.utc(`${startDate}T${exportEndTime}`);
        // If end time is before start time return invalid (false)
        if (endTime.isBefore(startTime)) {
            return false;
        }
        // Maintenance window start and end times
        const maintenanceStart = dayjs_1.default.utc(`${startDate}T03:00:00`);
        const maintenanceEnd = dayjs_1.default.utc(`${startDate}T04:59:59`);
        // Check if the range falls within the maintenance window
        return !((startTime.isBefore(maintenanceEnd) &&
            endTime.isAfter(maintenanceStart)) || // Overlapping with maintenance window
            (startTime.isAfter(maintenanceStart) &&
                startTime.isBefore(maintenanceEnd)) || // Start time within maintenance window
            (endTime.isAfter(maintenanceStart) && endTime.isBefore(maintenanceEnd)) || // End time within maintenance window
            startTime.isSame(maintenanceStart) ||
            startTime.isSame(maintenanceEnd) || // Start time is exactly on the maintenance window
            endTime.isSame(maintenanceStart) ||
            endTime.isSame(maintenanceEnd));
        // Valid if the entire range is outside the maintenance window
    }
    defaultMessage(args) {
        const options = args.constraints[1];
        return (options.message ||
            'The time range between Start Time and End Time must not overlap with the maintenance window (10 PM to 12 AM CST).\nStart time must be before end time.');
    }
};
exports.ExportTimeRangeConstraint = ExportTimeRangeConstraint;
exports.ExportTimeRangeConstraint = ExportTimeRangeConstraint = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'ExportTimeRange', async: false })
], ExportTimeRangeConstraint);
